import { matrixConstants } from 'utils/Constants';

export const meedioMatrixFetchFn: typeof globalThis.fetch = (input, init) => {
  const mergedInit: RequestInit = {
    ...init,
    headers: {
      ...init?.headers,
      [matrixConstants.MATRIX_CLIENT_HEADER_NAME]: matrixConstants.MATRIX_CLIENT_HEADER_VALUE,
    },
  };

  return globalThis.fetch(input, mergedInit);
};
